import React from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const InnerHeader = ({ title = "Notifications", onBack }) => {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  return (
    <div
      style={{
        display: "flex",
        paddingVertical: 10,
        paddingHorizontal: 10,
        backgroundColor: "var(--inner-header-bg)",
        gap: 15,
        alignItems: "center",
        gap: 12,
        padding: 10,
      }}
    >
      <ChevronLeft size={28} onClick={goBack} />
      <h2
        style={{
          color: "var(--inner-header-title-color)",
          fontSize: 18,
          fontWeight: "600",
          marginRight: 17,
          width: "100%",
          textAlign: "center",
        }}
      >
        {title}
      </h2>
    </div>
  );
};

export default InnerHeader;